import React from 'react';

import { Select } from '@lyearn/ui';
import { getSelectOptionLabel } from '@/components/Form/components/Select/getOptionLabel';
import { CustomFrequencyEnum } from '@/types/schema';

export const OPTIONS = [
  { value: CustomFrequencyEnum.Day, label: 'Daily' },
  { value: CustomFrequencyEnum.Week, label: 'Weekly' },
  { value: CustomFrequencyEnum.Month, label: 'Monthly' },
];

const HabitFrequencySelector = ({
  value = CustomFrequencyEnum.Day,
  onChange,
  className,
}: {
  value?: CustomFrequencyEnum;
  onChange: (value: CustomFrequencyEnum) => void;
  className?: string;
}) => {
  return (
    <Select
      disableClearable
      className={className ?? 'w-[20.2rem]'}
      getOptionLabel={getSelectOptionLabel}
      options={OPTIONS}
      size="large"
      value={value}
      onChange={onChange}
    />
  );
};

export default HabitFrequencySelector;
